/* eslint-disable */
import { argumentsError, execute, overload } from '../concrete'

const moduleName = 'concrete'

const AnnualLoginService = {
  /**
   * 农机年审登录
   * @param {*} username 账号
   * @param {*} password 密码
   * @returns Promise
   */
  AppUpgradeVersion: function (platform, appType) {
    return execute(moduleName, `/AppUpgradeVersion/selectAppUpgradeVersion`, 'json', 'POST', {
      platform: platform,
      appType: appType
    })
  },
  /**
   * 农机年审退出登录
   * @returns Promise
   */
  logOut: function () {
    return execute(moduleName, `/Annual/Login/logOut`, 'json', 'GET')
  }
}

export default AnnualLoginService
